import { APIEndpoints } from "@/data/constants/endpoints";
import { Request } from "@/data/api/utils/network";
import { RequestParams } from "@/data/types";
import { TDashboardSectionItem, TDashboardSectionPayload } from "@/data/types";

/**
 * Get all dashboardSections with pagination options
 * @param params Request parameters including organization_id, pageNumber, pageSize, etc.
 */
export const getAllDashboardSections = (params: RequestParams) => {
  return Request({
    path: APIEndpoints.DASHBOARD_SECTIONS.BASE,
    type: "GET",
    params,
  });
};

/**
 * Create a new dashboardSection
 * @param params Request parameters
 * @param payload Create payload
 */
export const createDashboardSection = (
  params: RequestParams,
  payload: TDashboardSectionPayload
) => {
  return Request({
    path: APIEndpoints.DASHBOARD_SECTIONS.BASE,
    type: "POST",
    params,
    body: payload,
  });
};

/**
 * Get a dashboardSection by ID
 * @param dashboardSectionId The ID of the dashboardSection to retrieve
 * @param params Request parameters
 */
export const getDashboardSectionById = (dashboardSectionId: string, params: RequestParams) => {
  return Request({
    path: APIEndpoints.DASHBOARD_SECTIONS.BY_ID(dashboardSectionId),
    type: "GET",
    params,
  });
};

/**
 * Update a dashboardSection by ID
 * @param dashboardSectionId The ID of the dashboardSection to update
 * @param params Request parameters
 * @param payload Update payload
 */
export const updateDashboardSection = (
  dashboardSectionId: string,
  params: RequestParams,
  payload: Partial<TDashboardSectionPayload>
) => {
  return Request({
    path: APIEndpoints.DASHBOARD_SECTIONS.BY_ID(dashboardSectionId),
    type: "PATCH",
    params,
    body: payload,
  });
};

/**
 * Delete a dashboardSection by ID
 * @param dashboardSectionId The ID of the dashboardSection to delete
 * @param params Request parameters
 */
export const deleteDashboardSection = (dashboardSectionId: string, params: RequestParams) => {
  return Request({
    path: APIEndpoints.DASHBOARD_SECTIONS.BY_ID(dashboardSectionId),
    type: "DELETE",
    params,
  });
};